import {Grid, Typography} from '@mui/material';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import Dialog from 'components/Dialog';
import Formik from 'components/hook-form/Formik';
import FormikRadioButton from 'components/inputs/FormikRadioButton';
import Panel from 'components/Panel';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

type Props = {
   onClose: (type?: boolean) => void;
};

const BackupTypeChooser = memo(({onClose}: Props) => {
   const {t} = useTranslation();

   return (
      <Dialog maxWidth={'md'} open={true} close={onClose} header={t('Choose Backup Type')}>
         <Formik
            initialValues={{
               type: 'true',
            }}
            initialTouched={['type']}
            onSubmit={(values) => onClose(values.type === 'true')}
         >
            <>
               <Panel>
                  <Typography>{t('What type of backup file do you want to create?')}</Typography>
                  <Typography>
                     {t(
                        'Select Backup to save all transactions, partners, keys and configuration\n' +
                           'settings. Select Merge to save a list of transactions and their related\n' +
                           'partners and keys.'
                     )}
                  </Typography>
                  <Grid container spacing={5} justifyContent="center">
                     <Grid item>
                        <FormikRadioButton
                           autoFocus
                           name="type"
                           label={t('Backup (*.dbu)')}
                           value="true"
                        />
                     </Grid>
                     <Grid item>
                        <FormikRadioButton name="type" label={t('Merge (*.dmrg)')} value="false" />
                     </Grid>
                  </Grid>
               </Panel>
               <FormFooterButtons enableOk cancel={onClose} />
            </>
         </Formik>
      </Dialog>
   );
});

export default BackupTypeChooser;
